module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (149).c913e39d.jpg";